export var ACTION_COMMANDS_QUEUE = {
  ENTER_LOBBY_1: 'ENTER_LOBBY_1',
  ENTER_LOBBY_2: 'ENTER_LOBBY_2',
  ENTER_LOBBY_3: 'ENTER_LOBBY_3',
  ENTER_LOBBY_4: 'ENTER_LOBBY_4'
};